import React, { useEffect, useState } from 'react';
import styles from './AuthNavigation.module.scss';
import logo from '../../../../assets/procertyLogo_beta_light.png';
import LogoLink from '../../../../common/PublicNavigation/LogoLink/LogoLink';
import useWindowSize from '../../../../hooks/useWindowSize/useWindowSize';
import HamburgerButton from '../../../../common/PublicNavigation/HamburgerButton/HamburgerButton';
import { useLocation } from 'react-router-dom';
import { translate } from '../../../../utility/messageTranslator/translate';
import { useIntl } from 'react-intl';
import { connect } from 'react-redux';
import { StoreState } from '../../../../config/StoreProvider/StoreProvider';
import { User } from '../../../../domain/User';
import { ThunkDispatch } from 'redux-thunk';
import { AnyAction } from 'redux';
import * as authService from '../../../../store/auth/service';
import { ReactSVG } from 'react-svg';
import phoneIcon from '../../../../assets/icons/call-calling.svg';
import cx from 'classnames';

type Props = {
  currentUser: User | null;
  onLogout: () => void;
};

export const MOBILE_BREAK_POINT = 900;

const AuthNavigation = ({ currentUser, onLogout }: Props) => {
  const { width } = useWindowSize();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();
  const intl = useIntl();

  useEffect(() => {
    if (width && width > MOBILE_BREAK_POINT) {
      setIsMobileMenuOpen(false);
    }
  }, [width]);

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location.key]);

  const getContactInfo = () => {
    return (
      <div className={styles.contactContainer}>
        <p className={styles.contactHeader}>
          {translate(intl, 'AUTH_NAVIGATION.CONTACT_HEADER')}
        </p>

        <div className={styles.phoneContainer}>
          <ReactSVG className={styles.phoneIcon} src={phoneIcon} />
          <a
            href={`tel:${translate(intl, 'AUTH_NAVIGATION.CONTACT_PHONE')}`}
            className={styles.phoneText}
          >
            {translate(intl, 'AUTH_NAVIGATION.CONTACT_PHONE_TEXT')}
          </a>
        </div>
      </div>
    );
  };

  return (
    <header className={styles.authNavigationContainer}>
      <div className={styles.innerNavigation}>
        <LogoLink logoSrc={logo} isNotSvg logoClassName={styles.logo} />
        {width && width > MOBILE_BREAK_POINT && getContactInfo()}
        {width && width < MOBILE_BREAK_POINT && (
          <HamburgerButton
            isMobileMenuOpen={isMobileMenuOpen}
            clickHandler={() => setIsMobileMenuOpen((prevState) => !prevState)}
          />
        )}
      </div>

      {width && width < MOBILE_BREAK_POINT && isMobileMenuOpen && (
        <div className={cx(styles.mobileMenuLinks, styles.mobile)}>
          {getContactInfo()}
        </div>
      )}
    </header>
  );
};

const mapStateToProps = (state: StoreState) => ({
  currentUser: state.user.currentUser,
});

const mapDispatchToProps = (dispatch: ThunkDispatch<any, any, AnyAction>) => ({
  onLogout: () => dispatch(authService.logoutUser()),
});

export default connect(mapStateToProps, mapDispatchToProps)(AuthNavigation);
